<section class="sh-dialog__content sh-overflow-container">
    <ng-container *ngTemplateOutlet="!(facetsLoading$ | async) ? facetList : loading; context: { facet }"> </ng-container>

    <ng-container *ngIf="facetError">
        <sh-notification [type]="notificationType.Error" [message]="'facets.facet-search-dialog.error' | translate" [icon]="'delete'"></sh-notification>
    </ng-container>
</section>

<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="submit" class="sh-button sh-action-group__item" (click)="submit()">{{ SUBMIT_LABEL }}</button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ CANCEL_LABEL }}</button>
    </div>
</footer>

<ng-template #facetList let-facet="facet">
    <sh-form-text-input
        *ngIf="showSearch"
        [label]="''"
        [placeholder]="'facets.facet-search-dialog.search-placeholder' | translate"
        [id]="'facet-search-dialog'"
        [control]="facetsSearchControl"
        [autocompleteFct]="autocompleteFunction"
        [inOverflownContainer]="true"
        [errorMsg]="autocompleteErrorMsg"
        [autoFocus]="true"
        (selectedSuggestions)="onSelectedSuggestion($event)"
    ></sh-form-text-input>
    <sh-facet
        *ngIf="facet.values.length > 0; else empty"
        [facet]="facet"
        [facetDialogOpen]="true"
        [showLabel]="false"
        [showMoreMsg]="'ui.load-more' | translate"
        (loadMore)="onLoadMore()"
        (valueSelected)="onValueSelected($event)"
    ></sh-facet>
</ng-template>

<ng-template #empty class="sh-dialog__content">{{ "facets.no-results" | translate }}</ng-template>

<ng-template #loading class="sh-dialog__content">
    <sh-facet-placeholder [showLabel]="false" class="sh-facet-search-placeholder"></sh-facet-placeholder
></ng-template>
